<template>
  <div>
    <h2>Esta estrategia tuvo una tasa de rebote duro superior a lo recomendado</h2>
    <h3>¿Cómo mejorar en el envío de tus correos?</h3>
    <p>
      Se recomienda tener una tasa de rebote inferior a 1%. Este correo electrónico tuvo una tasa de
      rebote duro mayor. Esto se puede deber a que los contactos ya no están activos o tiene correos
      electrónicos desactualizados. Te recomendamos limpiar tu lista para evitar rebotes duros en el
      futuro.
    </p>
    <p>Artículos recomendados</p>
    <ul>
      <li>Cómo limpiar tu lista de contactos para mejorar la capacidad de entrega</li>
      <li>Comprender la capacidad de entrega</li>
    </ul>
  </div>
</template>
<style lang="sass" scoped>
h2
  text-align: center
</style>
